import { svgIcon } from "@bitwarden/components";

export const BitwardenShield = svgIcon`
<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="-90.00 -75.00 500 500.00">
<path fill="#0d4053ff" d="
  M 27.63 130.86
  C 26.83 126.10 28.32 120.39 28.73 117.31
  Q 29.31 112.97 30.95 109.40
  Q 34.28 102.17 36.09 99.36
  Q 43.09 88.53 54.49 82.65
  Q 58.67 80.49 59.88 79.54
  C 62.02 77.85 64.47 76.18 66.93 75.13
  C 71.50 73.19 75.00 69.95 79.28 67.59
  Q 97.24 57.71 97.77 57.45
  C 101.15 55.81 103.17 54.02 106.28 52.66
  Q 107.52 52.11 109.60 50.65
  Q 114.35 47.30 115.51 46.74
  Q 123.04 43.15 130.10 38.73
  Q 136.16 34.94 138.33 33.78
  Q 145.51 29.94 146.77 29.18
  C 149.87 27.30 153.95 27.05 157.65 26.17
  Q 160.28 25.55 162.64 25.52
  Q 172.18 25.41 173.75 25.58
  Q 183.90 26.64 192.64 31.89
  Q 194.24 32.85 206.10 39.98
  Q 206.16 40.01 210.53 42.32
  C 212.71 43.47 214.78 45.38 217.12 46.49
  Q 223.01 49.26 228.80 53.22
  C 230.09 54.10 232.13 54.60 233.67 55.69
  Q 241.67 61.34 250.99 65.70
  C 254.11 67.16 257.30 69.83 260.80 71.47
  Q 263.25 72.61 264.02 73.28
  C 265.27 74.36 266.73 75.38 268.11 76.11
  Q 275.74 80.10 283.10 84.12
  Q 285.46 85.41 287.32 87.37
  Q 289.86 90.03 293.17 92.92
  Q 294.72 94.27 296.87 97.26
  Q 303.03 105.83 306.27 116.07
  Q 307.38 119.60 307.37 124.12
  Q 307.34 136.41 307.35 240.78
  Q 307.35 244.50 303.98 247.23
  C 302.71 248.25 301.56 248.46 300.02 247.74
  Q 293.41 244.68 285.07 239.60
  C 282.71 238.16 279.82 237.07 277.58 235.34
  Q 276.03 234.15 273.26 232.96
  C 271.24 232.09 269.48 230.29 267.67 229.29
  Q 263.78 227.13 260.23 224.93
  A 3.45 3.44 -74.1 0 1 258.60 222.00
  Q 258.53 184.01 258.61 141.50
  Q 258.62 138.16 256.03 131.51
  Q 254.93 128.70 252.33 125.68
  C 250.17 123.18 247.70 119.27 243.62 117.46
  C 239.55 115.66 236.17 113.18 232.17 111.29
  Q 230.00 110.26 228.19 108.91
  C 226.79 107.88 224.97 106.34 223.04 105.36
  Q 217.41 102.51 211.86 99.54
  Q 210.69 98.91 205.79 95.85
  Q 203.07 94.15 201.66 93.63
  Q 199.42 92.79 197.58 91.16
  Q 195.88 89.65 192.64 87.91
  Q 189.96 86.47 187.57 84.77
  Q 179.63 79.12 169.22 78.12
  Q 166.07 77.82 163.30 78.45
  C 160.66 79.06 158.27 78.77 155.53 80.13
  Q 152.46 81.66 150.30 82.36
  C 146.66 83.54 144.79 86.29 141.40 87.96
  C 137.32 89.97 133.76 91.61 130.44 94.21
  Q 128.21 95.95 126.91 96.68
  Q 122.09 99.37 109.12 106.12
  Q 105.49 108.02 101.06 111.20
  Q 98.36 113.13 95.76 114.50
  Q 91.55 116.70 90.32 117.57
  Q 83.61 122.30 78.27 131.35
  Q 76.58 134.21 76.01 137.85
  Q 75.19 142.98 75.19 144.75
  Q 75.20 161.01 75.23 214.25
  Q 75.23 218.00 76.00 222.79
  Q 76.69 227.07 79.20 230.62
  Q 82.79 235.69 85.57 238.68
  Q 87.65 240.91 91.95 243.05
  Q 95.48 244.81 100.99 248.55
  Q 105.43 251.56 110.24 253.97
  Q 115.90 256.82 122.26 260.69
  C 124.10 261.81 128.68 263.81 131.59 265.98
  Q 134.07 267.83 135.36 268.58
  Q 145.42 274.41 145.96 274.58
  Q 146.01 274.59 150.02 277.03
  C 153.93 279.40 158.09 280.86 162.83 280.62
  Q 165.86 280.47 170.02 280.64
  Q 174.02 280.80 178.48 279.67
  Q 181.28 278.97 185.95 275.89
  Q 186.51 275.52 193.38 271.47
  Q 209.84 261.77 212.73 260.42
  Q 215.50 259.14 220.83 255.50
  Q 224.64 252.89 229.08 250.74
  C 231.48 249.58 233.17 247.98 235.53 246.81
  Q 245.02 242.14 246.47 241.23
  Q 248.94 239.67 249.98 239.65
  Q 250.21 239.65 254.35 239.74
  Q 256.38 239.78 258.40 241.12
  Q 261.63 243.26 266.34 245.40
  Q 269.04 246.62 274.06 249.96
  Q 282.51 255.57 291.47 259.98
  C 293.95 261.20 295.72 262.88 294.52 265.72
  C 293.73 267.58 291.66 269.01 289.81 270.63
  Q 288.82 271.50 287.61 272.24
  C 283.82 274.53 280.62 277.43 276.86 278.95
  C 274.62 279.85 271.97 281.78 269.72 283.02
  Q 255.99 290.59 250.19 293.66
  C 246.90 295.39 243.75 298.32 240.31 300.08
  Q 228.06 306.34 217.28 313.31
  C 212.78 316.22 208.29 318.47 203.42 320.90
  Q 202.31 321.46 199.52 323.66
  Q 197.37 325.36 195.51 326.18
  Q 185.57 330.53 179.28 332.99
  Q 176.62 334.03 173.46 334.04
  Q 170.62 334.05 161.09 333.95
  Q 157.60 333.91 155.58 333.03
  C 153.50 332.12 150.97 331.86 148.37 330.73
  Q 141.00 327.56 134.72 323.42
  Q 128.82 319.54 123.75 316.79
  Q 112.82 310.85 108.48 308.25
  Q 92.53 298.70 82.57 293.29
  Q 78.53 291.09 73.59 287.92
  Q 68.33 284.54 64.33 282.57
  Q 57.25 279.08 53.70 276.49
  C 51.54 274.91 48.26 273.77 46.49 272.02
  C 43.40 268.96 38.67 264.72 36.24 260.75
  Q 29.43 249.59 27.72 239.01
  Q 26.88 233.87 27.57 227.01
  Q 28.25 220.15 28.27 216.08
  Q 28.40 173.57 28.24 136.07
  Q 28.23 134.45 27.63 130.86
  Z"
/>
<path fill="#0d4053ff" d="
  M 206.15 113.85
  Q 207.74 115.14 212.74 117.70
  Q 217.49 120.13 219.45 121.29
  Q 225.80 125.02 232.09 129.29
  C 237.36 132.87 240.18 137.08 242.52 143.11
  Q 243.87 146.59 243.92 152.16
  Q 244.18 181.07 243.95 209.34
  Q 243.91 214.59 242.57 218.03
  Q 240.83 222.52 238.25 226.39
  Q 236.27 229.36 232.81 231.61
  Q 222.34 238.38 216.99 241.20
  Q 208.16 245.86 205.75 247.81
  Q 202.86 250.16 199.71 251.41
  Q 197.63 252.23 194.49 254.34
  C 190.19 257.23 185.61 259.16 180.95 261.82
  Q 175.72 264.80 173.17 265.29
  Q 169.09 266.07 164.45 265.96
  Q 161.96 265.90 158.37 264.41
  C 156.25 263.53 153.20 262.69 150.57 261.11
  Q 144.53 257.51 135.04 252.10
  C 132.26 250.52 129.91 248.28 127.05 246.88
  Q 117.77 242.35 111.50 238.46
  Q 110.49 237.83 109.24 236.85
  C 106.89 235.00 103.19 233.80 101.62 232.63
  Q 99.71 231.21 94.94 226.11
  Q 92.51 223.51 91.11 219.77
  Q 90.07 217.01 90.04 212.56
  Q 89.76 169.43 90.03 146.00
  C 90.08 141.56 93.59 136.57 96.47 133.04
  Q 98.85 130.11 101.96 128.45
  Q 104.41 127.14 106.71 125.20
  Q 108.39 123.78 111.53 122.15
  Q 124.55 115.42 134.67 109.41
  C 136.48 108.34 138.48 106.45 140.76 105.26
  Q 150.09 100.40 153.06 98.82
  Q 155.25 97.66 159.03 96.27
  Q 161.40 95.41 164.57 95.38
  Q 168.95 95.34 170.25 95.45
  Q 176.87 96.03 182.13 99.37
  C 185.65 101.60 188.33 103.82 192.40 105.77
  C 198.51 108.70 202.19 110.63 206.15 113.85
  Z"
/>

</svg>
`;
